"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contactAgent = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var StaticContentState_1 = require("@/pages/staticContent/states/StaticContentState");
var PublicPage_1 = require("@/pages/common/components/PublicPage");
var mapStateToProps = function (state) { return (__assign({}, state.staticContent)); };
var mapDispatchToProps = function () { return ({}); };
exports.contactAgent = function (props) {
    var renderContents = function (rows) {
        var getUnsafeHtml = function (message) {
            var attr = {
                dangerouslySetInnerHTML: { __html: message },
            };
            return attr;
        };
        return rows.map(function (it, index) {
            var classes = 'o-p';
            switch (it.type) {
                case StaticContentState_1.StaticContentTypes.MODAL: {
                    classes = 'c-modal';
                    break;
                }
                case StaticContentState_1.StaticContentTypes.PARAGRAPH: {
                    classes = 'o-p';
                    break;
                }
                case StaticContentState_1.StaticContentTypes.HEADER: {
                    classes = 'o-h2 l-pad--2 l-pad-top--3';
                    break;
                }
            }
            return (React.createElement("div", __assign({ key: index, className: classes }, getUnsafeHtml(it.text))));
        });
    };
    return (React.createElement(PublicPage_1.default, null,
        React.createElement("div", { className: "g-reset l-container l-container--lr" },
            React.createElement("div", { className: "l-container__main l-pad-top" },
                React.createElement("div", { className: "c-page-header c-page-header--center c-page-header--center-mobile" },
                    React.createElement("div", { className: "c-page-header__title" }, props.title)),
                renderContents(props.content)))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.contactAgent);
